import { Navigate, Route, Routes } from 'react-router';
import { useAuth } from './lib/auth';
import { Layout, visiblePages } from './components/Layout';
import { LoadingPage } from './components/ui';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import ForcedTwoFactor from './pages/account/ForcedTwoFactor';
import { PAGES } from './modules';

export default function App() {
  const { me, loading, can } = useAuth();
  if (loading) return <LoadingPage />;
  if (!me) return <Login />;
  if (me.user.mustChangePassword) return <ChangePassword forced />;
  // Zwei-Faktor-Pflicht für Administratoren: bis zur Einrichtung sperrt der Server alles außer Einrichtung/Abmelden
  const needs2fa = me.needs2faSetup ?? (me.user.role === 'admin' && !me.user.totpEnabled && me.settings['auth.require_2fa_admin'] === true);
  if (needs2fa) return <ForcedTwoFactor />;

  const pages = visiblePages(can);
  // Startseite: Übersicht für Leitung, sonst Kasse
  const home = pages.find((p) => p.path === '/') ? '/' : pages.find((p) => p.path === '/kasse') ? '/kasse' : pages[0]?.path ?? '/konto';

  return (
    <Routes>
      {pages.map((p) => (
        <Route key={p.path} path={p.path === '/' ? '/' : `${p.path}/*`} element={<Layout page={p}><p.component /></Layout>} />
      ))}
      {PAGES.filter((p) => !pages.includes(p)).map((p) => (
        p.path === '/'
          // ohne Übersicht-Recht (z. B. Kassierer) direkt zur eigenen Startseite
          ? <Route key={p.path} path="/" element={<Navigate to={home} replace />} />
          : <Route key={p.path} path={`${p.path}/*`} element={<Layout><div className="empty">Für diese Seite fehlt dir die Berechtigung.</div></Layout>} />
      ))}
      <Route path="*" element={<Navigate to={home} replace />} />
    </Routes>
  );
}
